module.exports = __webpack_public_path__ + "static/media/piggy_bank_icon.27b6c8cb.svg";